<script>
import Layout from '@layouts/main';
import ReportForm from '@views/reports/form';

export default {
  components: {
    Layout,
    ReportForm,
  },
  page() {
    return {
      title: this.$t('titles.create_report'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.reports'),
          to: { name: 'reports.index' },
        },
        {
          text: this.$t('titles.create_report'),
          active: true,
        },
      ],
      allExpensesHaveScanLocal: true,
      reportLocal: {
        user_id: null,
        user: null,
        company_id: null,
        company: null,
        vip_id: null,
        vip: null,
        vip_description: null,
        meeting_point: null,
        meeting_date: null,
        locked: 0,
        completed: 0,
        abroad: 0,
        times_registered: 0,
        only_costs: 0,
      },
    };
  },
  methods: {
    create(report) {
      this.$router.push({
        name: 'reports.edit',
        params: {
          id: report.id,
        },
        query: {
          create: 1,
        },
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_report')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-class="d-flex flex justify-content-between"
      header-text-variant="white"
      class="mb-3"
    >
      <template v-slot:header>
        <div>{{ $t('titles.report_details') }}</div>
        <b-form-checkbox v-if="reportLocal" v-model="reportLocal.only_costs" name="check-button" switch :value="1" :unchecked-value="0">
          <span class="text-light">{{ $t('fields.only_costs') }}</span>
        </b-form-checkbox>
      </template>
      <ReportForm v-model="reportLocal" :all-expenses-have-scan="allExpensesHaveScanLocal" @submitted="create" />
    </b-card>
  </Layout>
</template>
